import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import download from "downloadjs";

import { API_ROOT } from "../../../api/constants";

import { getCurrentUser } from "../../user/user.selectors";

import React, { Component } from "react";

import { ContentBlock } from "../../pages/components";
import Button from "../../../ui/button/Button";

class TotalSalesBlock extends Component {
  doSubmit = () => {
    const { currentUser } = this.props;
    const channel = currentUser.channel._id;
    const token = localStorage.getItem("cmore-sisapiiri-token");
    const url = `${API_ROOT}api/transaction/export?channelId=${channel}`;
    const init = {
      method: "POST",
      headers: new Headers({
        authtoken: `${token}`
      })
    };

    fetch(url, init)
      .then(function(resp) {
        return resp.blob();
      })
      .then(function(blob) {
        download(blob);
      });
  };

  renderHeaderActions = () => {
    return (
      <Button onClick={() => this.doSubmit()}>
        Tulosta myyntihistoria
      </Button>
    );
  };

  render() {
    return <ContentBlock title="Kokonaismyyntitilanne" renderActions={this.renderHeaderActions} />;
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  return {
    currentUser
  };
};

const ConnectedTotalSalesBlock = connect(mapStateToProps)(TotalSalesBlock);

export default withRouter(ConnectedTotalSalesBlock);



// WEBPACK FOOTER //
// ./src/modules/transaction/components/TotalSalesBlock.js